import api from '@/service/driver';
import createStore from '@/store/base/create-store';
const { state, actions, mutations } = createStore(api);
import { PAGE_TYPE, pageTypes } from '@/config/enums';

const tempState = {
    // 页面配置
    pageOption: {
        campaignSourceCode: '', // 来源code cykKliLxZK
        origin: '', // 试驾入口渠道
        carType: 'ES7'
    },
    pageType: '', // ../config/enums.js pageType
    // 是否nioapp打开
    isNIOApp: false,
    showCustomHeader: false,
    // 成功页面
    successStatus: '',
    // 成功数据
    succeedData: {},
    // 当前车型
    carType: 'es7',
    // 访问时间
    accessTime: new Date().getTime(),
    // 登陆信息
    loginInfo: {},
    // 试驾单详情
    driveOrderInfo: {},
    // 是否可被邀请
    inviteable: true,
    // 敬请期待
    comingSoon: false,
    ...state
};

const tempMutations = {
    ...mutations,
    setPageOption(state, data) {
        const sourceData = data;
        state.pageOption = _.merge(state.pageOption, sourceData);
        let carType = (state.pageOption.carType || 'es7').toLowerCase();
        if (carType === 'et5') {
            carType = 'pegasus';
        }
        state.carType = carType;
    },
    setPageType(state, data) {
        state.pageType = data || 'driver';
    },
    setIsNIOApp(state, data) {
        state.isNIOApp = data;
    },
    setShowCustomHeader(state, data) {
        state.showCustomHeader = data;
    },
    // /components/succeed/config.js 的 key
    setSuccessStatus(state, data) {
        if (_.isObject(data)) {
            state.successStatus = data.status;
            state.succeedData = data.data || {};
        } else {
            state.successStatus = data;
        }
    },
    setCarType(state, data) {
        state.carType = (data || 'es7').toLowerCase();
        if (state.carType === 'et5') {
            state.carType = 'pegasus';
        }
        state.pageOption.carType = state.carType;
    },
    setLoginInfo(state, data) {
        state.loginInfo = data || {};
    },
    setDriveOrderInfo(state, data) {
        state.driveOrderInfo = data || {};
    },
    setUserInviteable(state, data) {
        state.inviteable = data;
    },
    setComingSoon(state, data) {
        state.comingSoon = data;
    }
};

const tempActions = {
    ...actions,
    getOrderInfo({ dispatch, commit }, param) {
        return dispatch('userIdentityTestDriveByOrderNo', {
            ...param,
            order_no: param.order_no
        }).then(res => {
            if (res.data) {
                commit('setDriveOrderInfo', res.data);
            }
            return res;
        });
    },
    /**
     * 试驾单列表
     * @param {*} param0 
     * @param {*} param 
     */
    getTestDriveOrders({ dispatch, commit, state }, param) {
        // ../config/enums.js
        commit('setDriveOrderInfo', {});
        return dispatch('testDriveOrderList', param).then(res => {
            const orderList = res.data.list || [];
            if (orderList.length > 0) {
                const orderItem = orderList[0];
                console.log('orderItem', orderItem);
                dispatch('getOrderInfo', {
                    ...param,
                    order_no: orderItem.order_no
                })
                    .then(orderInfoRes => {
                        if (orderInfoRes.data) {
                            commit('setDriveOrderInfo', orderInfoRes.data);
                            const tempCarType = (orderInfoRes.data.car_type ||
                                'es6'
                            )
                                .toLowerCase()
                                .split(',')[0]; // fab二维码创建的试驾单可能为多车型
                            commit(
                                'setCarType',
                                tempCarType === 'et5' ? 'pegasus' : tempCarType
                            );
                        }
                    })
                    .catch(() => {
                        commit('setDriveOrderInfo', orderItem);
                    });
            }
        });
    },
    getUserInviteable({ dispatch, commit, state }) {
        return dispatch('userInviteable', {
            headers: { authorization: state.loginInfo.access_token }
        }).then(res => {
            commit('setUserInviteable', res.data);
        });
    }
};
const tempGetters = {
    getConfigCarInfo(state) {
        const carInfo = state.configCarData[state.carType];
        if (carInfo) {
            return carInfo;
        }
        return {};
    },
    defaultCampaignCode(state) {
        return state.getCompatibleCodeData.campaign_code.atDrive || '';
    }
};

const store = {
    namespaced: true,
    strict: true,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations,
    getters: tempGetters
};
export default store;



// WEBPACK FOOTER //
// ./src/store/at-driver.js